module.exports = __webpack_public_path__ + "927a441de15bcede13d95fc12217836d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/crown-beaded-s.png
// module id = 2172
// module chunks = 0